import React from "react"
import { css } from "@emotion/core"
import { P } from "../../Partials/Typography"
import ReactHtmlParser from "react-html-parser"

const UserStoryQuotes = ({ copy }) => {
    return (
        <>
            <P
                css={css`
                    padding-bottom: 6rem;
                    &:last-of-type {
                        padding-bottom: 4rem;
                `}
            >
                ...{ReactHtmlParser(copy.quote)}...
            </P>
        </>
    )
}
export default UserStoryQuotes
